<template>
  <div id="error404" class="flex-align">
    <a-result status="success" title="恭喜您，认证已完成" sub-title="请您关闭此窗口页面，返回Easyloon平台继续提交信息" />
  </div>
</template>
<style lang="less" scoped>
#error404 {
  justify-content: center;
  height: 100vh;
}
</style>

